import { defineComponent } from "vue";
export default defineComponent({
  name: "MyLoading",
  components: {},

  setup() {
    return {};
  }

});